var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1db39d99bf1fd02440db8c778835b45c.svg#h';
                    var viewUrl = 'sprites.1db39d99bf1fd02440db8c778835b45c.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };